import React, { useState, useEffect, useContext, useReducer } from 'react'
import { Box, TextField, InputLabel } from '@mui/material'
import { PercentFormatInputDefault } from '../../Utils/PercentInputDefault'
import ColorButton from '../../Buttons/ColorButton'
import { externalComponent } from '../../AppRoutes'
import { api } from '../../../services/api'
import toast from 'react-hot-toast'
import { defaultReducer, lockedReducer } from '../../Utils/reducers'

const changePercent = (id, value, rows, setRows) => {
    const row = rows.find(row => row.id === id)
    row.value_perc = value * 100
    setRows([...rows])
}

const changeValue = (id, value, rows, setRows) => {
    const row = rows.find(row => row.id === id)
    row.value = value
    setRows([...rows])
}

const changeFloat = (id, value, rows, setRows) => {
    const row = rows.find(row => row.id === id)
    row.value_float = value.replace(',', '.')
    setRows([...rows])
}

const initialize = async (setLoader, setrows) => {
    setLoader(true)
    const res = await api.get('pedidos_conf/')
    if (res.status === 200) {
        setrows(res.data)
    }
    setLoader(false)
}

const saveConfigs = async (setLoader, rows) => {
    const payload = rows.flatMap(row => {
        let selected_data = null
        let selected_value = null
        switch (row.data_type) {
            case 'PERC':
                selected_data = 'value_perc'
                selected_value = row.value_perc
                break
            case 'VALUE':
                selected_data = 'value'
                selected_value = row.value
                break
            case 'VALUEFLOAT':
                selected_data = 'value_float'
                selected_value = row.value_float
                break

            default:
                return null
        }
        return { id: row.id, type: selected_data, value: selected_value }
    })
    setLoader(true)
    const res = await api.post('pedidos_conf/', payload)
    if (res.status === 200) {
        toast.success('Configurações salvas com sucesso')
    }
    setLoader(false)
}

const PedidoConfigs = () => {

    const [rows, setRows] = useState([])
    const { setLoader } = useContext(externalComponent)

    useEffect(() => {
        initialize(setLoader, setRows)
    }, [])

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', gap: '1rem' }}>
                {rows && rows.flatMap(row => {
                    if (row.data_type == 'PERC')
                        return (<Box>
                            <InputLabel>{row.name}</InputLabel>
                            <TextField
                                id={row.key}
                                type="text"
                                value={row.value_perc / 100}
                                onChange={(e) => changePercent(row.id, e.target.value, rows, setRows)}
                                fullWidth={false}
                                size='small'
                                InputProps={{
                                    inputComponent: PercentFormatInputDefault,
                                }}
                                onKeyDown={(e) => e.stopPropagation()}
                            />

                        </Box>)
                    else if (row.data_type === 'VALUE')
                        return (<Box>
                            <InputLabel>{row.name}</InputLabel>
                            <TextField
                                id={row.key}
                                type="text"
                                value={row.value}
                                onChange={(e) => changeValue(row.id, e.target.value, rows, setRows)}
                                fullWidth={false}
                                size='small'
                                onKeyDown={(e) => e.stopPropagation()}
                            />

                        </Box>)
                    else if (row.data_type === 'VALUEFLOAT')
                        return (<Box>
                            <InputLabel>{row.name}</InputLabel>
                            <TextField
                                id={row.key}
                                type="text"
                                value={row.value_float}
                                onChange={(e) => changeFloat(row.id, e.target.value, rows, setRows)}
                                fullWidth={false}
                                size='small'
                                onKeyDown={(e) => e.stopPropagation()}
                            />

                        </Box>)
                })}
                <Box>
                    <ColorButton onClick={() => saveConfigs(setLoader, rows)} sx={{ height: '2.5rem' }}>Salvar</ColorButton>
                </Box>
            </Box>
        </>
    )
}

export default PedidoConfigs;